export default __webpack_public_path__ + "static/media/greenarrow.d861ecdf.svg";